import React, { useState } from "react";
import { IonButton } from "@ionic/react";
import {  finishRevealAbility, useGameState } from "context/GameContext";
// Comps
import RevealAbilityItem from "./components/RevealAbilityItem/RevealAbilityItem";
// Css
import classes from "./RevealAbility.module.scss";

const RevealAbility: React.FC = () => {
  const [reveal, setReveal] = useState(false);
  const { drawRules,code } = useGameState();

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Reveal Session</h2>
      <div className={classes.wrapper}>
        {drawRules.slice(0, 3).map((item, index) => (
          <RevealAbilityItem item={item} reveal={reveal} key={index} />
        ))}
      </div>
      <p className={classes.description}>
        If you are the enacting president, click on the reveal button to see
        these next three polices.
      </p>
      {reveal ? (
        <IonButton
          size="small"
          onClick={() => finishRevealAbility(code)}
        >
          done
        </IonButton>
      ) : (
        <IonButton size="small" onClick={() => setReveal(true)}>
          reveal
        </IonButton>
      )}
    </div>
  );
};

export default RevealAbility;
